import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import { t } from "@/i18n-js/instance";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FormHeadingBlock",
  props: {
    value: {
      prop: "other",
      type: "string",
      value: "Form Heading",
    },
    textType: {
      prop: "other",
      type: "select",
      value: "title",
      options: [
        {
          label: t("builder_ui.prop_type.heading_types.title"),
          value: "title",
        },
        {
          label: t("builder_ui.prop_type.heading_types.subtitle"),
          value: "subtitle",
        },
      ],
    },
  },
};
